import styled from 'styled-components';

export const FormWrapper = styled.form`
	display: flex;
	flex-direction: column;
	width: 100%;
`;

export const MaskedInputWrapper = styled.div`
	display: flex;
	flex-direction: column;
`;

export const Label = styled.div`
	margin-bottom: 8px;
	font-size: 14px;
	font-weight: 500;
	color: ${({ theme }) => theme.colors.text.alwaysWhite};

	span {
		color: ${({ theme }) => theme.colors.text.error};
	}
`;

export const MaskedInput = styled.div<{ $hasError: boolean }>`
	display: flex;
	align-items: center;
	gap: 12px;
	padding: 14px 16px;
	border: 1px solid ${({ theme, $hasError }) => 
		$hasError ? theme.colors.text.error : theme.borders.border200};
	border-radius: 8px;
	background-color: ${({ theme }) => theme.colors.transparent.light10};
	
	input {
		border: none;
		outline: none;
		background: none;
		color: ${({ theme }) => theme.colors.text.alwaysWhite};
		font-size: 16px;

		&::placeholder {
			color: ${({ theme }) => theme.colors.transparent.light50};
		}
	}
`;

export const InputIcon = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 20px;
	height: 20px;
	
	svg {
		fill: ${({ theme }) => theme.colors.transparent.light50};
	}
`;

export const PasswordConditions = styled.div`
	display: flex;
	flex-direction: column;
	gap: 4px;
	margin-top: 8px;
`;

export const PasswordCondition = styled.div<{ $hasError: boolean }>`
	font-size: 14px;
	font-weight: 400;
	color: ${({ theme, $hasError }) => 
		$hasError ? theme.colors.text.error : theme.colors.text.body};
	margin-left: 8px;
	position: relative;

	&::before {
		content: '';
		position: absolute;
		top: 50%;
		left: -8px;
		transform: translateY(-50%);
		width: 2px;
		height: 2px;
		border-radius: 50%;
		background-color: ${({ theme, $hasError }) => 
			$hasError ? theme.colors.text.error : theme.colors.text.body};
	}
`;

export const CheckboxOption = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 8px 12px;
	background-color: ${({ theme }) => theme.colors.transparent.light10};
	border: 1px solid ${({ theme }) => theme.colors.transparent.light10};
	border-radius: 8px;
`;

export const CheckboxText = styled.div`
	font-size: 14px;
	font-weight: 400;
	color: ${({ theme }) => theme.colors.text.body};
	flex: 1;
`;

export const CheckboxLink = styled.span`
	color: ${({ theme }) => theme.colors.control.primary};
	cursor: pointer;
	text-decoration: underline;

	&:hover {
		color: ${({ theme }) => theme.colors.control.hover};
	}
`;

export const CheckboxIcon = styled.div<{ $isChecked: boolean }>`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 16px;
	height: 16px;
	border-radius: 2px;
	background-color: ${({ theme, $isChecked }) => 
		$isChecked ? theme.colors.icon.main : theme.colors.transparent.light50};
	color: ${({ theme }) => theme.colors.text.alwaysWhite};
	font-size: 12px;
	font-weight: bold;
	cursor: pointer;
	transition: background-color 0.2s ease;

	svg {
		fill: ${({ theme }) => theme.colors.text.alwaysDark};

		path {
			fill: ${({ theme }) => theme.colors.text.alwaysDark};
			stroke: ${({ theme }) => theme.colors.text.alwaysDark};
		}
	}
`;

export const Error = styled.div`
	color: ${({ theme }) => theme.colors.text.error};
	font-size: 14px;
	text-align: center;
	margin-top: 8px;
`; 
